import React from 'react';

const Chip = ({ children, className }) => <div className={['chip-wrapper', className].join(' ')}>
  <span className="chip-text">
    {children}
  </span>
</div>

export default Chip;